<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-select v-model="model.Status" 
                                      label="Status" 
                                       clearable clear-icon="close"
                                       
                                      :options="dataSourceFreshDeskTicketStatus" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[]"
                                      :error="fieldHasError('Status')"
                                      :error-message="fieldErrorMessage('Status')"
                                      
                                      @input="onStatusChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" >
                            <q-select v-model="model.LastTicketUpdateDateRange" 
                                      label="Last Ticket Update Date Range" 
                                       clearable clear-icon="close"
                                       
                                      :options="dataSourceFreshDeskTicketDateRangeType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[]"
                                      :error="fieldHasError('LastTicketUpdateDateRange')"
                                      :error-message="fieldErrorMessage('LastTicketUpdateDateRange')"
                                      
                                      @input="onLastTicketUpdateDateRangeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './freshdeskticketlistfiltermodel-dialog-screen.js'
</script>